import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    useBlocksContext,
    useAuthContext,
    useModalsContext,
    useStoreConfigContext,
    useCartContext
} from '/src/providers';
import * as styles from './styles.scss';

const Title = ({ name }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <h3
            className={`${styles.title}${isOpen ? ` ${styles.open}` : ` ${styles.close}`}`}
            onClick={() => setIsOpen(!isOpen)}
        >
            {name}
        </h3>
    )
};

const Item  = ({ items, handleShowAccount, isAuth, disabled }) => (
    <ul className={styles.sub}>
        {
            items.map(({ uid, name, url_key }) => (
                <li key={uid}>
                    {
                        url_key.includes('/customer') && !isAuth
                            ? <button onClick={handleShowAccount} disabled={disabled}>{name}</button>
                            : <Link to={url_key}>{name}</Link>
                    }
                </li>
            ))
        }
    </ul>
);

const Footer = () => {
    const {
        storeConfig: {
            footer_logo_src,
            footer_logo_alt,
        },
        translate,
    } = useStoreConfigContext();
    const { isAuth } = useAuthContext();
    const { isLoadingCart } = useCartContext();
    const { showModal, MODALS_TYPES } = useModalsContext();
    const { footerMenu } = useBlocksContext();
    const { company_info, service_info, account_info, policy_info } = footerMenu;

    const handleShowAccount = () => showModal(MODALS_TYPES.ACCOUNT);

    return (
        <footer>
            <div className={styles.wrapper}>
                <div className={styles.footer}>
                    <div>
                        <div className={styles.menu}>
                            <div className={styles.contacts}>
                                <Link
                                    className={styles.logo}
                                    to="/"
                                >
                                    <img src={footer_logo_src} alt={footer_logo_alt} />
                                </Link>
                                <a
                                    className={styles.email}
                                    href="mailto:support@buywholefoodsonline.co.uk"
                                >
                                    support@buywholefoodsonline.co.uk
                                </a>
                                <button
                                    className={styles.bot}
                                    onClick={() => {
                                        if (window.Intercom) {
                                            Intercom('show');
                                        }
                                    }}
                                >
                                    {translate('Quick Message')}
                                </button>
                            </div>
                            <div className={styles.item}>
                                <Title name={company_info.name} />
                                <Item
                                    items={company_info.children}
                                    handleShowAccount={handleShowAccount}
                                    isAuth={isAuth}
                                    disabled={isLoadingCart}
                                />
                            </div>
                            <div className={styles.item}>
                                <Title name={service_info.name} />
                                <Item
                                    items={service_info.children}
                                    handleShowAccount={handleShowAccount}
                                    isAuth={isAuth}
                                    disabled={isLoadingCart}
                                />
                            </div>
                            <div className={styles.item}>
                                <Title name={account_info.name} />
                                <Item
                                    items={account_info.children}
                                    handleShowAccount={handleShowAccount}
                                    isAuth={isAuth}
                                    disabled={isLoadingCart}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={styles.bottom}>
                        <div className={styles.carts}>
                            <div className={styles.visa} />
                            <div className={styles.mastercard} />
                            <div className={styles.amex} />
                            <div className={styles.discover} />
                            <div className={styles.paypal} />
                        </div>
                        <div className={styles.policy}>
                            {
                                policy_info.children.map(({ uid, name, url_key }) => (
                                    url_key.includes('/customer') && !isAuth
                                        ? <button onClick={handleShowAccount} key={uid} disabled={isLoadingCart}>{name}</button>
                                        : <Link to={url_key} key={uid}>{name}</Link>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
};

export default Footer;
